<template>
    <div class="main">
        <div class="recruit-block">
            <h2>{{title}}</h2>
            <p>更新于：{{time}}</p>
            <div v-html="info"></div>
        </div>
    </div>
</template>
<script>
import * as apis from "@/api/other"
export default {
    data(){
        return {
            info: '',
            title: '',
            time: ''
        }
    },
    mounted(){
        let id = this.$route.params.id;
        this.getDetailInfo(id);
    },
    methods: {
        async getDetailInfo(id){
            try{
                let data = {
                    id
                }
                let res = await apis.getRecruitInfo(data);
                if(res.code == 200){
                    this.info = res.data.text;
                    this.title = res.data.title;
                    this.time = res.data.updated_at
                }
            }catch(e){
                console.log(e)
            }
        }
    }
}
</script>
<style lang="less" scoped>
.recruit-block{
    background: #fff;
    border: 1px solid #ccc;
    padding: 50px 30px;
    margin: 50px 0;
    h2{
        text-align: center;
        font-size: 30px;
        line-height: 50px;
    }
    p{
        text-align: right;
        font-size: 14px;
    }
}
</style>